import { Injectable } from '@angular/core';

import { Observable, BehaviorSubject } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { State } from '@progress/kendo-data-query';

import { GridDataResult } from '@progress/kendo-angular-grid';

import { HttpClient } from '@angular/common/http';

import { AppNotificationsService } from '@libs/portal-common/system';
import { DateToStringUtc } from './extensions/date-to-string';

export interface IAuditLog {
  Id: number;
  UserName: string;
  UserId: number;
  Section: string;
  Subsection: string;
  ActionType: string;
  ExecutionTime: Date;
  ClientIpAddress: string;
  BrowserInfo: string;
}

export class AuditLogFilter {
  LotId: number;
  From: Date;
  To: Date;
  UserId: number;
  Action: string;
  constructor() {
    const now = new Date();
    this.From = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
    this.To = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
  }
}

@Injectable({ providedIn: 'root' })
export class AuditListService extends BehaviorSubject<GridDataResult> {
  defaultState: State = {
    skip: 0,
    take: 20,
    group: [],
    filter: { logic: 'and', filters: [] },
    sort: [],
  };

  constructor(
    private _httpClient: HttpClient,
    private notifications: AppNotificationsService,
  ) {
    super(null);
  }

  public query(filter: AuditLogFilter, state: State): void {
    this.getAuditLogList(filter, state).subscribe((x) => {
      super.next(x);
    });
  }

  public clear(): void {
    super.next(<GridDataResult>{
      data: [],
      total: 0,
    });
  }

  getAuditLogList(filter: AuditLogFilter, state: State = this.defaultState): Observable<GridDataResult> {
    let requestFilter = this.constructFilter(filter, state);

    return this._httpClient.post<any>('Lot/Audit', requestFilter).pipe(
      tap((response) => {
        this.notifications.checkResponse(response);
      }),
      map(
        (response) =>
          <GridDataResult>{
            data: response.Groups || response.Data || [],
            total: response.Total,
          },
      ),
    );
  }

  constructFilter(filter: AuditLogFilter, state: State) {
    let stateFilter = JSON.parse(
      JSON.stringify(
        state.filter || {
          logic: 'and',
          filters: [],
        },
      ),
    );

    let params = {
      group: state.group,
      filter: stateFilter,
      skip: state.skip,
      limit: state.take,
      sort: state.sort,
    };

    let filtersArr = params.filter.filters;

    filtersArr.push({ field: 'LotId', operator: 'eq', value: filter.LotId });
    filtersArr.push({ field: 'UserId', operator: 'isnotnull' });
    filtersArr.push({ field: 'Form', operator: 'eq', value: 'LocationManagement' });

    if (filter.From) {
      filtersArr.push({ field: 'ExecutionTime', operator: 'gt', value: DateToStringUtc(filter.From) });
    }
    if (filter.To) {
      filtersArr.push({ field: 'ExecutionTime', operator: 'lt', value: DateToStringUtc(filter.To) });
    }
    if (filter.UserId) {
      filtersArr.push({ field: 'UserId', operator: 'eq', value: filter.UserId });
    }
    if (filter.Action) {
      filtersArr.push({ field: 'ActionType', operator: 'eq', value: filter.Action });
    }

    return params;
  }
}
